export function isToday(date: Date): boolean {
    const today = new Date();
    date = new Date(date)
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  export function isOverdue(date: Date, allDay = false): boolean {
    if (!allDay) {
      const today = new Date();
      return new Date(date) < today;
    } else {
      const today = new Date();
      const taskDate = new Date(date);
      
      // Set both dates to midnight to compare just the date portion
      const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const taskDateOnly = new Date(taskDate.getFullYear(), taskDate.getMonth(), taskDate.getDate());
      
      // For all-day tasks, it's only overdue if the date is strictly before today
      return taskDateOnly < todayDateOnly;
    }
  }

export function formatDurationFromSeconds(seconds: number) {
    const secondsInDay = 86400; // 1 day = 86400 seconds
    const secondsInHour = 3600; // 1 hour = 3600 seconds
    const secondsInMinute = 60; // 1 minute = 60 seconds
  
    const days = Math.floor(seconds / secondsInDay); // Whole days
    seconds %= secondsInDay; // Remaining seconds after days
  
    const hours = Math.floor(seconds / secondsInHour); // Whole hours
    seconds %= secondsInHour; // Remaining seconds after hours
  
    const minutes = Math.floor(seconds / secondsInMinute); // Whole minutes
  
    return { days, hours, minutes };
  }